/**
 * 权限管理 相关菜单配置
 *
 */

// import Layout from "../components/layout";
import { lazyLoad } from "@/utils/lazyLoad";
const subject = [
  {
    // component: Layout,
    component: lazyLoad,
    path: "subject-menu",
    meta: {
      title: "专题管理",
      icon: "icon-subject",
    },
    children: [
      {
        path: "/subject/list",
        name: "SubjectManage",
        component: () => import("@/pages/subject/list/index.vue"),
        meta: {
          title: "专题列表",
          keepAlive: false,
        },
      },
    ],
  },
];
export default subject;
